import { render, staticRenderFns } from "./confAutoApprHolidays.vue?vue&type=template&id=1d9a4cac&"
import script from "./confAutoApprHolidays.vue?vue&type=script&lang=js&"
export * from "./confAutoApprHolidays.vue?vue&type=script&lang=js&"
import style0 from "./confAutoApprHolidays.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
